import { render } from "./Display.vue?vue&type=template&id=f174b092&ts=true"
import script from "./Display.vue?vue&type=script&lang=ts"
export * from "./Display.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__